"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadParticlesLinksInteraction = void 0;
const plugin_1 = require("./plugin");
const interaction_1 = require("./interaction");
async function loadParticlesLinksInteraction(tsParticles) {
    await (0, interaction_1.loadInteraction)(tsParticles);
    await (0, plugin_1.loadPlugin)(tsParticles);
}
exports.loadParticlesLinksInteraction = loadParticlesLinksInteraction;
